// Login
import Login from "Authentication/Login";
// Invoice Template
import InvoiceTemplate from "FrmGeneric/InvoiceTemplate";
// Error 500
import Error_500 from "components/Errors/Error_500";
// Dashboard
import DashBoard from "DashBoard";
// Company
import FrmMCompanyList from "Masters/MCompany/FrmMComapnyList";
import FrmMComapny from "Masters/MCompany/FrmCompany";
// Financial Year
import FrmFinancialYearListing from "Masters/MFinancialYear/FrmFinancialYearListing";
import FrmFinancialYearEntry from "Masters/MFinancialYear/FrmFinancialYearEntry";
// Banks
import FrmMBankList from "Masters/MBanks/FrmMBankList";
import FrmMBankEntry from "Masters/MBanks/FrmBank/components/FrmMBankEntry";
// Departments
import FrmMDepartmentList from "Masters/MDepartment/FrmMDepartmentList";
import FrmDepartmentEntry from "Masters/MDepartment/FrmDepartmentEntry";
// Designations
import FrmMDesignationList from "Masters/MDesignation/FrmMDesingnationList";
import FrmDesignation from "Masters/MDesignation/FrmDesignation";
// Employees
import FrmMEmployeeList from "Masters/MEmployee/FrmMEmployeesList";
import MEmployeeEntry from "Masters/MEmployee/MEmployeeEntry";
// Customers
import FrmMCustomerList from "Masters/MCustomer/FrmMCustomerList";
import FrmCustomerEntry from "Masters/MCustomer/FrmCustomerEntry";
// Suppliers
import FrmSpplierList from "Masters/MSupplier/FrmSupplierList";
import FrmSupplier from "Masters/MSupplier/FrmSupplier";
// Agents
import FrmAgentList from "Masters/MAgent/FrmAgentList";
import FrmMAgent from "Masters/MAgent/FrmMAgent";
// Contractors
import FrmMContractorList from "Masters/MContractor/FrmMContractorList";
import FrmContractorEntry from "Masters/MContractor/FrmContractorEntry";
// Transporter
import FrmMTransporterList from "Masters/MTransporter/FrmMTransporterList";
import FrmTransporter from "Masters/MTransporter/FrmTransporter";
// City
import FrmCityList from "Masters/MCity/FrmCityList";
import FrmCity from "FrmGeneric/MCity/FrmCity";
// Destinations
import FrmMDestinationList from "Masters/MDestination/FrmMDestinationList";
import FrmDestinationEntry from "Masters/MDestination/FrmDestinationEntry";
// Godown
import FrmGodownList from "Masters/MGodown/FrmGodownList";
import MGodownEntry from "Masters/MGodown/MGodownEntry";
// HSN-SAC Codes
import FrmMHSNSACList from "Masters/MHSN-SAC/FrmMHSN-SACList";
import FrmHSNSAC from "Masters/MHSN-SAC/FrmHSN-SAC";
// Payment Schedules
import FrmPaymentScheduleListing from "Masters/MPaymentSchedule/FrmPaymentScheduleListing";
import FrmPaymentScheduleEntry from "Masters/MPaymentSchedule/FrmPaymentScheduleEntry";
// Payments Terms
import FrmPaymentTemrsListing from "Masters/MPaymentTerms/FrmPaymentTermsListing";
import FrmPaymentTermsEntry from "Masters/MPaymentTerms/FrmPaymentTermsEntry";
// Tax Types
import FrmMTaxtypeList from "Masters/MTaxtype/FrmMTaxtypeListing";
import FrmMTaxtypeEntry from "Masters/MTaxtype/FrmMTaxtypeEntry";
// Taxations
import FrmMTaxationList from "Masters/MTaxation/FrmMTaxationList";
import FrmTaxationEntry from "Masters/MTaxation/FrmTaxationEntry";
// Shifts
import FrmShiftListing from "Masters/MShift/FrmShiftListing";
import FrmShiftEntry from "Masters/MShift/FrmShiftEntry";
// Holidays
import FrmHolidayListing from "Masters/MHoliday/FrmHolidayListing";
import FrmHolidayEntry from "Masters/MHoliday/FrmHolidayEntry"
// Product-Raw Materials
import FrmMProductRawMaterialList from "Masters/MProductRawMaterial/FrmMProductRawMaterialList";
import FrmMProductRawMaterial from "Masters/MProductRawMaterial/FrmMProductRawMaterial";
// Product Unit Conversions
import FrmproductUnitConversionListing from "Masters/MProductUnitConversion/FrmproductUnitConversionListing";
import FrmproductUnitConversionEntry from "Masters/MProductUnitConversion/FrmproductUnitConversionEntry";
// Product- Services
import FrmMServiceListing from "Masters/MService/FrmMServiceListing";
import FrmMServiceEntry from "Masters/MService/FrmMServiceEntry"
// Product Category 1
import FrmMProductCategory1Listing from "Masters/MProductCategory1/FrmProductCategory1Listing";
import FrmMProductCategory1Entry from "Masters/MProductCategory1/FrmProductCategory1Entry"
// Product Category 2
import FrmMProductCategory2Listing from "Masters/MProductCategory2/FrmMProductCategory2Listing";
import FrmMProductCategory2Entry from "Masters/MProductCategory2/FrmMProductCategory2Entry"
// Product Unit
import FrmProductUnitListing from "Masters/MProductUnit/FrmProductUnitListing";
import FrmProductUnitEntry from "Masters/MProductUnit/FrmProductUnitEntry";
// Product Packing
import FrmMProductPackingListing from "Masters/MProductPacking/FrmMProductPackingListing";
import FrmMProductPackingEntry from "Masters/MProductPacking/FrmMProductPackingEntry";
// Product Makes
import FrmMProductMakeListing from "Masters/MProductMake/FrmMProductMakeListing";
import FrmMProductMakeEntry from "Masters/MProductMake/FrmMProductMakeEntry";
// Product Grades
import FrmMProductMaterialGradeListing from "Masters/MProductMaterialGrade/FrmMProductMaterialGradeListing";
import FrmMProductMaterialGradeEntry from "Masters/MProductMaterialGrade/FrmMProductMaterialGradeEntry";
// Properties
import FrmPropertyListing from "Masters/MProperty/FrmPropertyListing";
import FrmPropertyEntry from "Masters/MProperty/FrmPropertyEntry";
// Communication Templates
import FrmCommunicationsMasterList from "Masters/MCommunicationsMaster/FrmCommunicationsMasterList";
import FrmCommunicationsMasterEntry from "Masters/MCommunicationsMaster/FrmCommunicationsMasterEntry";
// Common Parameters
import CommonParamterListing from "Masters/MCommonParameter/CommonParamterListing";
import CommonParamterEntry from "Masters/MCommonParameter/CommonParamterEntry"
// Modules
import ModuleFormListing from "Masters/MAMModuleForm/ModuleFormListing";
import ModuleFormEntry from "Masters/MAMModuleForm/ModuleFormEntry";
// Cost Centers
import MCostCenterListing from "Masters/MFMCostCenter/MCostCenterListing/Index";
import MCostCenterEntry from "Masters/MFMCostCenter/MCostCenterEntry/Index";
// Profit Centers
import ProfitCenterListing from "Masters/ProfitCenter/ProfitCenterListing";
import ProfitCenterEntry from "Masters/ProfitCenter/ProfitCenterEntry";
// Schedules
import MFMScheduleLedgerListing from "Masters/MFMScheduleLedger/MFMScheduleLedgerListing";
import MFMScheduleLedgerEntry from "Masters/MFMScheduleLedger/MFMScheduleLedgerEntry";
// Generals
import MFMGeneralLedgerListing from "Masters/MFMGeneralLedger/MFMGeneralLedgerListing";
import MFMGeneralLedgerEntry from "Masters/MFMGeneralLedger/MFMGeneralLedgerEntry";
// Plants
import FrmPlantlist from "Masters/MPlant/FrmPlantList";
import FrmPlantEntry from "Masters/MPlant/FrmPlantEntry";
// Machines
import FrmMachineListing from "Masters/MMachine/FrmMachinelisting";
import FrmMachineEntry from "Masters/MMachine/FrmMachineEntry";
// Production Process
import MFrmProductionProcessListing from "Masters/MProductionProcess/MFrmProductionProcessListing";
import MFrmProductionProcessEntry from "Masters/MProductionProcess/MFrmProductionProcessEntry";
// Spinning Plan
import FrmMProductionSpinningPlanParameterListing from "Masters/MXMProductionSpinningPlanParameter/FrmMProductionSpinningPlanParameterListing";
import FrmMProductionSpinningPlanParameterEntry from "Masters/MXMProductionSpinningPlanParameter/FrmMProductionSpinningPlanParameterEntry";
// Production Stopage Reasons
import MFrmProductionStoppageReasonsListing from "Masters/MProductionStoppageReasons/MFrmProductionStoppageReasonsListing";
import MFrmProductionStoppageReasonsEntry from "Masters/MProductionStoppageReasons/MFrmProductionStoppageReasonsEntry";
// Production Wastage Types
import MFrmProductionWastageTypesListing from "Masters/MProductionWastageType/MFrmProductionWastageTypesListing";
import MFrmProductionWastageTypesEntry from "Masters/MProductionWastageType/MFrmProductionWastageTypesEntry";
// Spinning Counts
import FrmCountListing from "Masters/MCount/FrmCountListing";
import FrmCountEntry from "Masters/MCount/FrmCountEntry";
// Maintainance Tasks Master
import FrmMaintenanceTaskMasterListing from "Masters/MmaintenanceTaskMaster/FrmMaintenanceTaskMasterListing";
import FrmMaintenanceTaskMasterEntry from "Masters/MmaintenanceTaskMaster/FrmMaintenanceTaskMasterEntry";
// Maintainance Tasks Activity
import MmaintenanceTaskActivityListing from "Masters/MaintenanceTaskActivity/MmaintenanceTaskActivityListing";
import MmaintenanceTaskActivityEntry from "Masters/MaintenanceTaskActivity/MmaintenanceTaskActivityEntry";
// Electrical Meters
import MFrmProductionElectricalMeterListing from "Masters/MProductionElectricalMeter/MFrmProductionElectricalMeterListing";
import MFrmProductionElectricalMeterEntry from "Masters/MProductionElectricalMeter/MFrmProductionElectricalMeterEntry";
// Earning Heads
import FrmMHMEarningHeadsListing from "Masters/MHMEarningHeads/FrmMHMEarningHeadsListing";
import FrmMHMEarningHeadsEntry from "Masters/MHMEarningHeads/FrmMHMEarningHeadsEntry"
// Deductions Heads
import FrmMHMDeductionHeadsListing from "Masters/MHMDeductionHeads/FrmMHMDeductionHeadsListing";
import FrmMHMDeductionHeadsEntry from "Masters/MHMDeductionHeads/FrmMHMDeductionHeadsEntry"
// Product Type
import FrmMProductTypeListing from "Masters/MProductType/FrmProductTypeListing";
import FrmMProductTypeEntry from "Masters/MProductType/FrmProductEntry";
// Product- Finish Goods
import FrmMProductFGList from "Masters/MProductFG/FrmMProductFGList";
import FrmMProductFG from "Masters/MProductFG/FrmMProductFG"
// Product Category 3
import FrmMProductCategory3Listing from "Masters/MProductCategory3/FrmMProductCategory3Listing";
import FrmMProductCategory3Entry from "Masters/MProductCategory3/FrmMProductCategory3Entry";
// Product Category 4
import FrmMProductCategory4Listing from "Masters/MProductCategory4/FrmMProductCategory4Listing";
import FrmMProductCategory4Entry from "Masters/MProductCategory4/FrmMProductCategory4Entry";
// Product Category 5
import FrmMProductCategory5Listing from "Masters/MProductCategory5/FrmMProductCategory5Listing";
import FrmMProductCategory5Entry from "Masters/MProductCategory5/FrmMProductCategory5Entry";
// Product Process
import FrmMProductProcessList from "Masters/MProductProcess/FrmMProductProcessList";
import FrmProductProcessEntry from "Masters/MProductProcess/FrmProductProcessEntry";
// Product QA Parameters
import FrmMProductQaParametersListing from "Masters/MProductQaParameter/FrmProductQaParameterListing";
import FrmMProductQaParametersEntry from "Masters/MProductQaParameter/FrmMProductQaParameterEntry";
// Product Rejection Parameters
import FrmMProductRejectionParametersListing from "Masters/MProductRejectionParameters/FrmMProductRejectionParametersListing";
import FrmMProductRejectionParametersEntry from "Masters/MProductRejectionParameters/FrmMProductRejectionParametersEntry";
// Product Measure Parameters
import FrmMProductMaterialMeasureParametersListing from "Masters/MProductMaterialMeasureParameter/FrmMProductMaterialMeasureParameterListing";
import FrmMProductMaterialMeasureParametersEntry from "Masters/MProductMaterialMeasureParameter/FrmMProductMaterialMeasureParameterEntry";
// Product Shape
import FrmMProductMaterialShapeListing from "Masters/MProductMaterialShape/FrmMProductMaterialShapeListing";
import FrmMProductMaterialShapeEntry from "Masters/MProductMaterialShape/FrmMProductMaterialShapeEntry";
// Employee Type
import MEmployeeTypeListing from "Masters/MEmployeeType/MEmployeeTypeListing";

// Production Section
import FrmProductionSectionListing from "Masters/MProductionSection/FrmProductionSectionListing/Index";
import FrmProductionSectionEntry from "Masters/MProductionSection/FrmProductionSectionEntry";
// Production Sub Section
import FrmProductionSubSectionListing from "Masters/MProductionSubSection/FrmProductionSubSectionListing";
import FrmProductionSubSectionEntry from "Masters/MProductionSubSection/FrmProductionSubSectionEntry";
// Spin Plan
import FrmSpinPlanListing from "Masters/MProductionSpinPlan/MProductionSpinPlanListing";
import FrmSpinPlanEntry from "Masters/MProductionSpinPlan/MProductionSpinPlanEntry";
// Manual Attendance
import FrmManualAttendanceEntry from "Masters/MManualAttendance/FrmManualAttendanceEntry";

// Purchase Requisition
import IndentListing from "Transactions/TPurchaseOrder/Indent/IndentListing";
import FrmIndentMasterEntry from "Transactions/TPurchaseOrder/Indent/IndentEntry/Components/FrmIndentMasterEntry";
// PurchaPurchase Requisition (BOM)
import FrmPurchaseRequisitionListing from "Transactions/TPurchaseOrder/PurchaseRequisition/FrmPurchaseRequisitionListing";
import FrmPurchaseRequisitionEntry from "Transactions/TPurchaseOrder/PurchaseRequisition/PurchaseRequisitionEntry/Components/FrmPurchaseRequisitionEntry";
// Purchase Order (Trading)
import POListing from "Transactions/TPurchaseOrder/ManualPO/ManualPOListing";
import FrmPurchaseOrderEntry from "Transactions/TPurchaseOrder/ManualPO/FrmManualPOEntry";
// Goods Receipt Notes
import FrmGoodsReceiptNoteListing from "Transactions/TPurchaseOrder/GoodsReceiptNote/FrmGoodsReceiptNoteListing";
import FrmGoodsReceiptNoteEntry from "Transactions/TPurchaseOrder/GoodsReceiptNote/FrmGoodsReceiptNoteEntry";
// Customer Material Reciept
import FrmTCustomerRecieptListing from "Transactions/TCustomerReciept/FrmTCustomerRecieptListing";
import FrmTCustomerRecieptEntry from "Transactions/TCustomerReciept/FrmTCustomerRecieptEntry/Index";
// Purchase Bill Book(Auto)
import BillBookListing from "Transactions/TPurchaseOrder/TBillBook/BillBookListing";
import FrmBillBookEntry from "Transactions/TPurchaseOrder/TBillBook/FrmBillBookEntry";
// Purchase Bill Book(Manual)
import FrmManualBillBookListing from "Transactions/TPurchaseOrder/TManualBillBook/FrmManualBillBookListing";
import FrmManualBillBookEnrty from "Transactions/TPurchaseOrder/TManualBillBook/FrmManualBillBookEnrty";
// Purchase Payment Supplier
import FrmPurchasePaymentSupplierListing from "Transactions/TPurchaseOrder/TPurchasePaymentSupplier/FrmPurchasePaymentSupplierListing";
import FrmPurchasePaymentSupplierEntry from "Transactions/TPurchaseOrder/TPurchasePaymentSupplier/FrmPurchasePaymentSupplierEntry";
// Enquiry Management (Trading)
import FrmEnquiryListing from "Transactions/TEnquiryManagement/FrmEnquiryListing";
import FrmEnquiryTradingEntry from "Transactions/TEnquiryManagement/FrmEnquiryTradingEntry";
// Enquiry Management (Service)
import FrmEnquiryServiceListing from "Transactions/TEnquiryServiceManagement/FrmEnquiryServiceListing";
import FrmEnquiryServiceEntry from "Transactions/TEnquiryServiceManagement/FrmEnquiryServiceEntry";
// Enquiry Management (Project)
import FrmEnquiryProjectListing from "Transactions/TEnquiryProjectsManagement/FrmEnquiryProjectListing";
import FrmEnquiryProjectEntry from "Transactions/TEnquiryProjectsManagement/FrmEnquiryProjectEntry";
// Quotation (Trading)
import FrmQuotationListing from "Transactions/TQuotation/FrmQuotationListing";
import FrmQuotationMasterEntry from "Transactions/TQuotation/FrmQuotationMasterEntry";
// Quotation (Service)
import FrmQuotationServiceListing from "Transactions/TQuotationService/FrmQuotationServiceListing";
import FrmQuotationServiceEntry from "Transactions/TQuotationService/FrmQuotationServiceEntry";
// Quotation (Projects)
import FrmQuotationProjectListing from "Transactions/TQuotationProjects/FrmQuotationProjectListing";
import FrmQuotationProjectsEntry from "Transactions/TQuotationProjects/FrmQuotationProjectsEntry";
// Sales Order (Trading)
import SalesOrderListing from "Transactions/TSalesOrder/SalesOrderListing";
import SalesOrderEntry from "Transactions/TSalesOrder/SalesOrderEntry";
// Sales Order (Services)
import SOServiceListing from "Transactions/TSalesOrder/Services/SOServiceListing";
import SOServiceEntry from "Transactions/TSalesOrder/Services/SOServiceEntry";
// Sales Order (Projects)
import SalesOrderProjectsListing from "Transactions/TSalesOrder/Projects/SalesOrderProjectsListing";
import SalesOrderProjectEntry from "Transactions/TSalesOrder/Projects/SalesOrderProjectEntry";
// Work Order (Trading)
import FrmWorkOrderListing from "Transactions/TWorkOrderTrading/FrmWorkOrderListing";

// Dispatch Note (Trading)
import TDispatchNoteListing from "Transactions/TDispatchNote/TDispatchNoteListing";
import TDispatchNoteEntry from "Transactions/TDispatchNote/TDispatchNoteEntry";
// Dispatch Note (Projects)
import FrmDispatchNoteProjectsListing from "Transactions/TDispatchNoteProjects/FrmDispatchNoteProjectsListing";

// Dispatch Challan (Trading)
import TDispatchChallanListing from "Transactions/TDispatchChallan/TDispatchChallanListing";
import TDispatchChallanEntry from "Transactions/TDispatchChallan/TDispatchChallanEntry";
// Dispatch Challan (Projects)
import FrmDispatchChallanProjectsListing from "Transactions/TDispatchChallanProjects/FrmDispatchChallanProjectsListing";

// Dispatch Challan (Work Order)
import FrmDispatchChallanWorkOrderListing from "Transactions/TDispatchChallanWorkOrder/FrmDispatchChallanWorkOrderListing";

// Sales Invoice (Trading)
import FrmSalesInvoiceListing from "Transactions/TSalesInvoice/FrmSalesInvoiceListing";
import FrmSalesInvoiceEntry from "Transactions/TSalesInvoice/FrmSalesInvoiceEntry";
// Sales Invoice (Projects)
import FrmSalesInvoiceProjectsListing from "Transactions/TSalesInvoiceProjects/FrmSalesInvoiceProjectsListing";

// Sales Invoice (Job Work)
import FrmSalesInvoiceJobWorkListing from "Transactions/TSalesInvoiceJobWork/FrmSalesInvoiceJobWorkListing";

// Sales Invoice (Services)
import FrmSalesInvoiceServicesListing from "Transactions/TSalesInvoiceServices/FrmSalesInvoiceServicesListing";
// Leaves Application
import FrmLeavesApplicationListing from "./Masters/MLeavesApplication/FrmLeavesApplicationListing";
import FrmLeavesApplicationEntry from "./Masters/MLeavesApplication/FrmLeavesApplicationEntry";
//Attendance Device
import FrmAttendanceDeviceListing from "Masters/MAttendanceDevice/FrmAttendanceDeviceListing";
import FrmAttendanceDeviceEntry from "Masters/MAttendanceDevice/FrmAttendanceDeviceEntry";
// Leave Type
import FrmLeaveTypeEntry from "Masters/MLeaveType/FrmLeaveTypeEntry";
import FrmLeaveTypeListing from "Masters/MLeaveType/FrmLeaveTypeListing";
// Customer Sales Receipt
import FrmCustomerSalesReceiptListing from "Transactions/TPurchaseOrder/TPurchasePaymentCustomer/FrmCustomerSalesReceiptListing";
import FrmCustomerSalesReceiptEntry from "Transactions/TPurchaseOrder/TPurchasePaymentCustomer/FrmCustomerSalesReceiptEntry";
import FrmIndentMaterialIssueListing from "Transactions/TIndentMaterialIssue/FrmIndentMaterialIssueListing";
import FrmIndentMaterialIssueEntry from "Transactions/TIndentMaterialIssue/FrmIndentMaterialIssueEntry";
import FrmProfessionalTaxationEntry from "Masters/MProfessionalTaxation/FrmProfessionalTaxationEntry";
import FrmProductionListing from "Transactions/TProduction/FrmProductionListing";
import FrmProductionEntry from "Transactions/TProduction/FrmProductionEntry";
import FrmMCodificationEntry from "Masters/MCodification/FrmMCodificationEntry";
import MCodificationListing from "Masters/MCodification/MCodificationList";
import FrmJobTypeListing from "Masters/MJobType/FrmJobTypeListing";
import FrmJobTypeEntry from "Masters/MJobType/FrmJobTypeEntry";
import FrmLeavesEntry from "Masters/MLeaves/FrmLeavesEntry";
import FrmBankListListing from "Masters/MBankList/FrmBankListListing";
import FrmBankListEntry from "Masters/MBankList/FrmBankListEntry";
import FrmMSMVProductFgStocklisting from "Masters/MSMVProductFgStock/FrmMSMVProductFgStocklisting";
import FrmMSMVProductRmStockListing from "Masters/MSMVProductRmStock/FrmMSMVProductRmStockListing";
import FrmMProductMaterialTypeListing from "Masters/MProductMaterialType/FrmMProductMaterialTypelList";

// Customer Material Issue
import TCustomerMaterialIssueListing from "Transactions/TCustomerMaterialIssue/TCustomerMaterialIssueListing";
import TCustomerMaterialIssueEntry from "Transactions/TCustomerMaterialIssue/TCustomerMaterialIssueEntry";


const routes = [
    {
        route: "/login",
        component: <Login />,
        header: false,
        footer: true,
        protected: true
    },
    {
        route: "/Invoice",
        component: <InvoiceTemplate />,
        header: false,
        footer: false,
        protected: true
    },
    {
        route: "/Error",
        component: <Error_500 />,
        header: false,
        footer: false,
        protected: true
    },
    {
        route: "/DashBoard",
        component: <DashBoard />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Company",
        route: "/Masters/CompanyListing",
        component: <FrmMCompanyList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Company",
        component: <FrmMComapny />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Financial Year",
        route: "/Masters/MFinancialYear/FrmFinancialYearListing",
        component: <FrmFinancialYearListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MFinancialYear/FrmFinancialYearEntry",
        component: <FrmFinancialYearEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Banks",
        route: "/Masters/BankListing",
        component: <FrmMBankList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MBanks/FrmBank/FrmMBankEntry",
        component: <FrmMBankEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Departments",
        route: "/Masters/DepartmentListing",
        component: <FrmMDepartmentList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Department",
        component: <FrmDepartmentEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Designations",
        route: "/Masters/MDesignation/FrmMDesingnationList",
        component: <FrmMDesignationList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Designation",
        component: <FrmDesignation />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Employees",
        route: "/Masters/EmployeesListing",
        component: <FrmMEmployeeList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Employees",
        component: <MEmployeeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Customers",
        route: "/Masters/CustomerListing",
        component: <FrmMCustomerList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Customer",
        component: <FrmCustomerEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Suppliers",
        route: "/Masters/SupplierListing",
        component: <FrmSpplierList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmSupplier",
        component: <FrmSupplier />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Agents",
        route: "/Masters/AgentListing",
        component: <FrmAgentList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Agent",
        component: <FrmMAgent />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Contractors",
        route: "/Masters/ContractorListing",
        component: <FrmMContractorList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Contractor",
        component: <FrmContractorEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Transporter",
        route: "/Masters/TransporterListing",
        component: <FrmMTransporterList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Transporter",
        component: <FrmTransporter />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "City",
        route: "/Masters/CityListing",
        component: <FrmCityList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/City",
        component: <FrmCity />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Destinations",
        route: "/Masters/DestinationListing",
        component: <FrmMDestinationList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Destination",
        component: <FrmDestinationEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Godown",
        route: "/Masters/GodownListing",
        component: <FrmGodownList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Godown",
        component: <MGodownEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "HSN-SAC Codes",
        route: "/Masters/HSNSACListing",
        component: <FrmMHSNSACList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/HSNSAC",
        component: <FrmHSNSAC />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Payment Schedules",
        route: "/Masters/FrmPaymentScheduleListing",
        component: <FrmPaymentScheduleListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmPaymentScheduleEntry",
        component: <FrmPaymentScheduleEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Payments Terms",
        route: "FrmPaymentTemrsListing",
        component: <FrmPaymentTemrsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmPaymentTermsEntry",
        component: <FrmPaymentTermsEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Tax Types",
        route: "/Masters/TaxtypeListing",
        component: <FrmMTaxtypeList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Taxtype",
        component: <FrmMTaxtypeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Taxations",
        route: "/Masters/TaxationListing",
        component: <FrmMTaxationList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Taxation",
        component: <FrmTaxationEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Shifts",
        route: "Masters/MShift/FrmShiftListing",
        component: <FrmShiftListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmShiftEntry",
        component: <FrmShiftEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Holidays",
        route: "/Masters/MHoliday/FrmHolidayListing",
        component: <FrmHolidayListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MHoliday/FrmHolidayEntry",
        component: <FrmHolidayEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product-Raw Materials",
        route: "Masters/MProductRawMaterial/FrmMProductRawMaterialList",
        component: <FrmMProductRawMaterialList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/RawMaterial",
        component: <FrmMProductRawMaterial />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Unit Conversions",
        route: "Masters/MProductUnitConversion/FrmproductUnitConversionListing",
        component: <FrmproductUnitConversionListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmproductUnitConversionEntry",
        component: <FrmproductUnitConversionEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product- Services",
        route: "Masters/MService/FrmMServiceListing",
        component: <FrmMServiceListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MService/FrmMServiceEntry",
        component: <FrmMServiceEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Category 1",
        route: "Masters/MProductCategory1/FrmProductCategory1Listing",
        component: <FrmMProductCategory1Listing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductCategory1Master",
        component: <FrmMProductCategory1Entry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Category 2",
        route: "Masters/MProductCategory2/FrmMProductCategory2Listing",
        component: <FrmMProductCategory2Listing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductCategory2Master",
        component: <FrmMProductCategory2Entry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Unit",
        route: "Masters/MProductUnit/FrmProductUnitListing",
        component: <FrmProductUnitListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmProductUnitEntry",
        component: <FrmProductUnitEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Unit Conversions",
        route: "Masters/MProductUnitConversion/FrmproductUnitConversionListing",
        component: <FrmproductUnitConversionListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmproductUnitConversionEntry",
        component: <FrmproductUnitConversionEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Packing",
        route: "Masters/MProductPacking/FrmMProductPackingListing",
        component: <FrmMProductPackingListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductPacking",
        component: <FrmMProductPackingEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Makes",
        route: "Masters/MProductMake/FrmMProductMakeListing",
        component: <FrmMProductMakeListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductMake",
        component: <FrmMProductMakeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Grades",
        route: "Masters/MProductMaterialGrade/FrmMProductMaterialGradeListing",
        component: <FrmMProductMaterialGradeListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductMaterialGrade",
        component: <FrmMProductMaterialGradeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Company Settings",
        route: "/Masters/CompanyListing",
        component: <FrmMCompanyList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Company",
        component: <FrmMComapny />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Properties",
        route: "/Masters/FrmPropertyListing",
        component: <FrmPropertyListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmPropertyEntry",
        component: <FrmPropertyEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Communication Templates",
        route: "/Masters/MCommunicationsMaster/FrmCommunicationsMasterList",
        component: <FrmCommunicationsMasterList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MCommunicationsMaster/FrmCommunicationsMasterEntry",
        component: <FrmCommunicationsMasterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Common Parameters",
        route: "/Masters/MCommonParameter/CommonParamterListing",
        component: <CommonParamterListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MCommonParameter/CommonParamterEntry",
        component: <CommonParamterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Modules",
        route: "/Masters/ModuleFormListing",
        component: <ModuleFormListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ModuleFormEntry",
        component: <ModuleFormEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Financial Year",
        route: "/Masters/MFinancialYear/FrmFinancialYearListing",
        component: <FrmFinancialYearListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MFinancialYear/FrmFinancialYearEntry",
        component: <FrmFinancialYearEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Cost Centers",
        route: "/Masters/MCostCenterListing",
        component: <MCostCenterListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MCostCenterEntry",
        component: <MCostCenterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Profit Centers",
        route: "/Masters/ProfitCenterListing",
        component: <ProfitCenterListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProfitCenterEntry",
        component: <ProfitCenterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "HSN-SAC Codes",
        route: "/Masters/HSNSACListing",
        component: <FrmMHSNSACList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/HSNSAC",
        component: <FrmHSNSAC />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Payment Schedules",
        route: "/Masters/FrmPaymentScheduleListing",
        component: <FrmPaymentScheduleListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmPaymentScheduleEntry",
        component: <FrmPaymentScheduleEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Payments Terms",
        route: "/Masters/FrmPaymentTermsListing",
        component: <FrmPaymentTemrsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmPaymentTermsEntry",
        component: <FrmPaymentTermsEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Tax Types",
        route: "/Masters/TaxtypeListing",
        component: <FrmMTaxtypeList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Taxtype",
        component: <FrmMTaxtypeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Taxations",
        route: "/Masters/TaxationListing",
        component: <FrmMTaxationList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Taxation",
        component: <FrmTaxationEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Schedules",
        route: "/Masters/MFMScheduleLedgerListing",
        component: <MFMScheduleLedgerListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MFMScheduleLedgerEntry",
        component: <MFMScheduleLedgerEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Generals",
        route: "/Masters/MFMGeneralLedgerListing",
        component: <MFMGeneralLedgerListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MFMGeneralLedgerEntry",
        component: <MFMGeneralLedgerEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Plants",
        route: "/Masters/FrmPlantlist",
        component: <FrmPlantlist />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmPlantEntry",
        component: <FrmPlantEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Machines",
        route: "/Masters/FrmMachineListing",
        component: <FrmMachineListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmMachineEntry",
        component: <FrmMachineEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Shifts",
        route: "/Masters/FrmShiftListing",
        component: <FrmShiftListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmShiftEntry",
        component: <FrmShiftEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Production Holidays",
        route: "/Masters/MHoliday/FrmHolidayListing",
        component: <FrmHolidayListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MHoliday/FrmHolidayEntry",
        component: <FrmHolidayEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Production Process",
        route: "/Masters/MProductionProcess/MFrmProductionProcessListing",
        component: <MFrmProductionProcessListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MProductionProcess/MFrmProductionProcessEntry",
        component: <MFrmProductionProcessEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Spinning Plan",
        route: "/Masters/MXMProductionSpinningPlanParameter/FrmMProductionSpinningPlanParameterListing",
        component: <FrmMProductionSpinningPlanParameterListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MXMProductionSpinningPlanParameter/FrmMProductionSpinningPlanParameterEntry",
        component: <FrmMProductionSpinningPlanParameterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Production Stopage Reasons",
        route: "/Masters/MProductionStoppageReasons/MFrmProductionStoppageReasonsListing",
        component: <MFrmProductionStoppageReasonsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MProductionStoppageReasons/MFrmProductionStoppageReasonsEntry",
        component: <MFrmProductionStoppageReasonsEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Production Wastage Types",
        route: "/Masters/MProductionWastageType/MFrmProductionWastageTypesListing",
        component: <MFrmProductionWastageTypesListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MProductionWastageType/MFrmProductionWastageTypesEntry",
        component: <MFrmProductionWastageTypesEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Spinning Counts",
        route: "/Masters/MCount/FrmCountListing",
        component: <FrmCountListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MCount/FrmCountEntry",
        component: <FrmCountEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Maintainance Tasks Master",
        route: "/Masters/MmaintenanceTaskMaster/FrmMaintenanceTaskMasterListing",
        component: <FrmMaintenanceTaskMasterListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MmaintenanceTaskMaster/FrmMaintenanceTaskMasterEntry",
        component: <FrmMaintenanceTaskMasterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Maintainance Tasks Activity",
        route: "/Masters/MmaintenanceTaskActivity/MmaintenanceTaskActivityListing",
        component: <MmaintenanceTaskActivityListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MaintenanceTaskActivity/MmaintenanceTaskActivityEntry",
        component: <MmaintenanceTaskActivityEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Electrical Meters",
        route: "/Masters/MProductionElectricalMeter/MFrmProductionElectricalMeterListing",
        component: <MFrmProductionElectricalMeterListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MProductionElectricalMeter/MFrmProductionElectricalMeterEntry",
        component: <MFrmProductionElectricalMeterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Departments",
        route: "/Masters/DepartmentListing",
        component: <FrmMDepartmentList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Department",
        component: <FrmDepartmentEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Designations",
        route: "/Masters/DesignationListing",
        component: <FrmMDesignationList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Destination",
        component: <FrmDestinationEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Holidays",
        route: "/Masters/MHoliday/FrmHolidayListing",
        component: <FrmHolidayListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MHoliday/FrmHolidayEntry",
        component: <FrmHolidayEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Employees",
        route: "/Masters/EmployeesListing",
        component: <FrmMEmployeeList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Employees",
        component: <MEmployeeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Shifts",
        route: "/Masters/FrmShiftListing",
        component: <FrmShiftListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmShiftEntry",
        component: <FrmShiftEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Earning Heads",
        route: "/Masters/MHMEarningHeads/MHMEarningHeadsListing",
        component: <FrmMHMEarningHeadsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MHMEarningHeads/FrmMHMEarningHeadsEntry",
        component: <FrmMHMEarningHeadsEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Deductions Heads",
        route: "/Masters/MHMDeductionHeads/FrmMHMDeductionHeadsListing",
        component: <FrmMHMDeductionHeadsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MHMDeductionHeads/FrmMHMDeductionHeadsEntry",
        component: <FrmMHMDeductionHeadsEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "City",
        route: "/Masters/CityListing",
        component: <FrmCityList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/City",
        component: <FrmCity />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Destinations",
        route: "/Masters/DesignationListing",
        component: <FrmMDesignationList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/Destination",
        component: <FrmDestinationEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Type",
        route: "/Masters/ProductTypeListing",
        component: <FrmMProductTypeListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductType",
        component: <FrmMProductTypeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product-Raw Materials",
        route: "/Masters/RawMaterialListing",
        component: <FrmMProductRawMaterialList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/RawMaterial",
        component: <FrmMProductRawMaterial />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product- Finish Goods",
        route: "/Masters/FinishGoodsListing",
        component: <FrmMProductFGList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FinishGoods",
        component: <FrmMProductFG />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product- Services",
        route: "/Masters/FrmMServiceListing",
        component: <FrmMServiceListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MService/FrmMServiceEntry",
        component: <FrmMServiceEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Category 1",
        route: "/Masters/ProductCategory1Listing",
        component: <FrmMProductCategory1Listing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductCategory1Master",
        component: <FrmMProductCategory1Entry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Category 2",
        route: "/Masters/ProductCategory2Listing",
        component: <FrmMProductCategory2Listing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductCategory2Master",
        component: <FrmMProductCategory2Entry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Category 3",
        route: "/Masters/ProductCategory3Listing",
        component: <FrmMProductCategory3Listing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductCategory3Master",
        component: <FrmMProductCategory3Entry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Category 4",
        route: "/Masters/ProductCategory4Listing",
        component: <FrmMProductCategory4Listing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductCategory4Master",
        component: <FrmMProductCategory4Entry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Category 5",
        route: "/Masters/ProductCategory5Listing",
        component: <FrmMProductCategory5Listing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductCategory5Master",
        component: <FrmMProductCategory5Entry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Unit",
        route: "/Masters/FrmProductUnitListing",
        component: <FrmProductUnitListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmProductUnitEntry",
        component: <FrmProductUnitEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Unit Conversions",
        route: "/Masters/FrmproductUnitConversionListing",
        component: <FrmproductUnitConversionListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmproductUnitConversionEntry",
        component: <FrmproductUnitConversionEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Packing",
        route: "/Masters/ProductPackingListing",
        component: <FrmMProductPackingListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductPacking",
        component: <FrmMProductPackingEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Makes",
        route: "/Masters/ProductMakeListing",
        component: <FrmMProductMakeListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductMake",
        component: <FrmMProductMakeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Grades",
        route: "/Masters/ProductMaterialGradeListing",
        component: <FrmMProductMaterialGradeListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductMaterialGrade",
        component: <FrmMProductMaterialGradeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Process",
        route: "/Masters/FrmMProductProcessListing",
        component: <FrmMProductProcessList />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmProductProcessEntry",
        component: <FrmProductProcessEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product QA Parameters",
        route: "/Masters/ProductQaParametersListing",
        component: <FrmMProductQaParametersListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductQaParameters",
        component: <FrmMProductQaParametersEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Rejection Parameters",
        route: "/Masters/ProductRejectionParametersListing",
        component: <FrmMProductRejectionParametersListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductRejectionParameters",
        component: <FrmMProductRejectionParametersEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Measure Parameters",
        route: "/Masters/ProductMaterialMeasureParametersListing",
        component: <FrmMProductMaterialMeasureParametersListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/ProductMaterialMeasureParameters",
        component: <FrmMProductMaterialMeasureParametersEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Product Shape",
        route: "/Masters/ProductMaterialMeasureShapeListing",
        component: <FrmMProductMaterialShapeListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/FrmMProductMaterialShapeEntry",
        component: <FrmMProductMaterialShapeEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Employee Type",
        route: "/Masters/MEmployeeType/MEmployeeTypeListing",
        component: <MEmployeeTypeListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Production Section",
        route: "/Masters/MProductionSection/FrmProductionSectionListing",
        component: <FrmProductionSectionListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MProductionSection/FrmProductionSectionEntry",
        component: <FrmProductionSectionEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Production Sub Section",
        route: "/Masters/MProductionSubSection/FrmProductionSubSectionListing",
        component: <FrmProductionSubSectionListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MProductionSubSection/FrmProductionSubSectionEntry",
        component: <FrmProductionSubSectionEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Spin Plan",
        route: "/Masters/MProductionSpinPlan/MProductionSpinPlanListing",
        component: <FrmSpinPlanListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Masters/MProductionSpinPlan/MProductionSpinPlanEntry",
        component: <FrmSpinPlanEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Manual Attendance",
        route: "/Masters/MManualAttendance/FrmManualAttendanceEntry",
        component: <FrmManualAttendanceEntry />,
        header: true,
        footer: true,
        protected: false
    },
    // Job Type Master
    {
        type: "Masters",
        name: "Job Type",
        key: "Job Type",
        route: "/Masters/MJobType/FrmJobTypeListing",
        component: <FrmJobTypeListing />,
        noCollapse: true,
    },
    {
        name: "Job Type",
        route: "/Masters/MJobType/FrmJobTypeEntry",
        component: <FrmJobTypeEntry />,
    },

    //Leaves master
    {
        type: "Masters",
        name: "Leaves",
        key: "Leaves",
        route: "/Masters/MLeaves/FrmLeavesEntry",
        component: <FrmLeavesEntry />,
    },

    // Leves Application
    {
        type: "masters",
        name: "Leaves Application",
        key: "Leaves Application",
        route: "/Masters/MLeavesApplication/FrmLeavesApplicationListing",
        component: <FrmLeavesApplicationListing />,
        noCollapse: true,
    },
    {
        name: "Leaves Application",
        route: "/Masters/MLeavesApplication/FrmLeavesApplicationEntry",
        component: <FrmLeavesApplicationEntry />,
    },

    // Leave Type Master
    {
        type: "masters",
        name: "Leave Type",
        key: "Leave Type",
        route: "/Masters/MLeaveType/FrmLeaveTypeListing",
        component: <FrmLeaveTypeListing />,
        noCollapse: true,
    },
    {
        name: "Leave Type",
        route: "/Masters/MLeaveType/FrmLeaveTypeEntry",
        component: <FrmLeaveTypeEntry />,
    },

    // Attendance Device Master
    {
        type: "masters",
        name: "Attendance Device",
        key: "Attendance Device",
        route: "/Masters/MAttendanceDevice/FrmAttendanceDeviceListing",
        component: <FrmAttendanceDeviceListing />,
        noCollapse: true,
    },
    {
        name: "Attendance Device",
        route: "/Masters/MAttendanceDevice/FrmAttendanceDeviceEntry",
        component: <FrmAttendanceDeviceEntry />,
    },

    // Leave Type Master
    {
        type: "masters",
        name: "Leave Type",
        key: "Leave Type",
        route: "/Masters/MLeaveType/FrmLeaveTypeListing",
        component: <FrmLeaveTypeListing />,
        noCollapse: true,
    },
    {
        name: "Leave Type",
        route: "/Masters/MLeaveType/FrmLeaveTypeEntry",
        component: <FrmLeaveTypeEntry />,
    },

    {
        type: "Purchase",
        name: "Indent",
        route: "/Transactions/TPurchaseOrder/Indent/IndentListing",
        component: <IndentListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TPurchaseOrder/Indent/FrmIndentMasterEntry",
        component: <FrmIndentMasterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Purchase",
        name: "PurchaPurchase Requisition (BOM)",
        route: "/Transactions/TPurchaseOrder/PurchaseRequisition/FrmPurchaseRequisitionListing",
        component: <FrmPurchaseRequisitionListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TPurchaseOrder/PurchaseRequisition/PurchaseEntry/",
        component: <FrmPurchaseRequisitionEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Purchase",
        name: "Purchase Order (Trading)",
        route: "/Transactions/TPurchaseOrder/ManualPO/POListing",
        component: <POListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TPurchaseOrder/ManualPO/FrmPurchaseOrderEntry",
        component: <FrmPurchaseOrderEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Purchase",
        name: "Goods Receipt Notes",
        route: "/Transactions/TPurchaseOrder/GoodsReceiptNote/GoodsReceiptNoteListing",
        component: <FrmGoodsReceiptNoteListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TPurchaseOrder/GoodsReceiptNote/GoodsReceiptNoteEntry",
        component: <FrmGoodsReceiptNoteEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Purchase",
        name: "Customer Material Reciept",
        route: "/Transactions/TCustomerReciept/FrmTCustomerRecieptListing",
        component: <FrmTCustomerRecieptListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TCustomerReciept/FrmTCustomerRecieptEntry",
        component: <FrmTCustomerRecieptEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Purchase",
        name: "Purchase Bill Book(Auto)",
        route: "/Transactions/TPurchaseOrder/TBillBook/BillBookListing",
        component: <BillBookListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TPurchaseOrder/TBillBook/FrmBillBookEntry",
        component: <FrmBillBookEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Purchase",
        name: "Purchase Bill Book(Manual)",
        route: "/Transactions/TPurchaseOrder/TManualBillBook/FrmManualBillBookListing",
        component: <FrmManualBillBookListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TPurchaseOrder/TManualBillBook/FrmManualBillBookEnrty",
        component: <FrmManualBillBookEnrty />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Purchase",
        name: "Purchase Payment Supplier",
        route: "/Transactions/TPurchaseOrder/TPurchasePaymentSupplier/FrmPurchasePaymentSupplierListing",
        component: <FrmPurchasePaymentSupplierListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TPurchaseOrder/TPurchasePaymentSupplier/FrmPurchasePaymentSupplierEntry",
        component: <FrmPurchasePaymentSupplierEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Enquiry Management (Trading)",
        route: "/Transactions/TEnquiryManagement/FrmEnquiryListing",
        component: <FrmEnquiryListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TEnquiryManagement/FrmEnquiryTradingEntry",
        component: <FrmEnquiryTradingEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Enquiry Management (Service)",
        route: "/Transactions/TEnquiryServiceManagement/FrmEnquiryServiceListing",
        component: <FrmEnquiryServiceListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TEnquiryServiceManagement/FrmEnquiryServiceEntry",
        component: <FrmEnquiryServiceEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Enquiry Management (Project)",
        route: "/Transactions/TEnquiryProjectsManagement/FrmEnquiryProjectListing",
        component: <FrmEnquiryProjectListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TEnquiryProjectsManagement/FrmEnquiryProjectEntry",
        component: <FrmEnquiryProjectEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Quotation (Trading)",
        route: "/Transactions/TQuotation/FrmQuotationListing",
        component: <FrmQuotationListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TQuotation/FrmQuotationMasterEntry",
        component: <FrmQuotationMasterEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Quotation (Service)",
        route: "/Transactions/TQuotationService/FrmQuotationServiceListing",
        component: <FrmQuotationServiceListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TQuotationService/FrmQuotationServiceEntry",
        component: <FrmQuotationServiceEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Quotation (Projects)",
        route: "/Transactions/TQuotationProjects/FrmQuotationProjectListing",
        component: <FrmQuotationProjectListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TQuotationProjects/FrmQuotationProjectsEntry",
        component: <FrmQuotationProjectsEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Sales Order (Trading)",
        route: "/Transactions/TSalesOrder/SalesOrderListing",
        component: <SalesOrderListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TSalesOrder/SalesOrderEntry",
        component: <SalesOrderEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Sales Order (Services)",
        route: "/Transactions/TSalesOrder/Services/SOServiceListing",
        component: <SOServiceListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TSalesOrder/Services/SOServiceEntry",
        component: <SOServiceEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Sales Order (Projects)",
        route: "/Transactions/TSalesOrder/Projects/SalesOrderProjectsListing",
        component: <SalesOrderProjectsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TSalesOrder/Projects/SalesOrderProjectEntry",
        component: <SalesOrderProjectEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Work Order (Trading)",
        route: "/Transactions/TWorkOrder/Trading/WorkOrderListing",
        component: <FrmWorkOrderListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Dispatch Note (Trading)",
        route: "/Transactions/TDispatchNote/TDispatchNoteListing",
        component: <TDispatchNoteListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TDispatchNote/TDispatchNoteEntry",
        component: <TDispatchNoteEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Dispatch Note (Projects)",
        route: "/Transactions/TDispatchNoteProjects/FrmDispatchNoteProjectsListing",
        component: <FrmDispatchNoteProjectsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Dispatch Challan (Trading)",
        route: "/Transactions/TDispatchChallan/TDispatchChallanListing",
        component: <TDispatchChallanListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TDispatchChallan/TDispatchChallanEntry",
        component: <TDispatchChallanEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Dispatch Challan (Projects)",
        route: "/Transactions/TDispatchChallan/FrmDispatchChallanProjectsListing",
        component: <FrmDispatchChallanProjectsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Dispatch Challan (Work Order)",
        route: "/Transactions/TDispatchChallan/TDispatchChallanWorkOrderListing",
        component: <FrmDispatchChallanWorkOrderListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Sales Invoice (Trading)",
        route: "/Transactions/SalesInvoiceListing",
        component: <FrmSalesInvoiceListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/InvoiceCreationEntry",
        component: <FrmSalesInvoiceEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Sales Invoice (Projects)",
        route: "/Transactions/SalesInvoiceProjectsListing",
        component: <FrmSalesInvoiceProjectsListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Sales Invoice (Job Work)",
        route: "/Transactions/SalesInvoiceJobWorkListing",
        component: <FrmSalesInvoiceJobWorkListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Sales Invoice (Services)",
        route: "/Transactions/SalesInvoiceServicesListing",
        component: <FrmSalesInvoiceServicesListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Sales",
        name: "Customer Sales Receipt",
        route: "/Transactions/TPurchaseOrder/TPurchasePaymentCustomer/FrmCustomerSalesReceiptListing",
        component: <FrmCustomerSalesReceiptListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TPurchaseOrder/TPurchasePaymentCustomer/FrmCustomerSalesReceiptEntry",
        component: <FrmCustomerSalesReceiptEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "purchase",
        name: "Indent Material Issue",
        route: "/Transactions/TIndentMaterialIssue/FrmIndentMaterialIssueListing",
        component: <FrmIndentMaterialIssueListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TIndentMaterialIssue/FrmIndentMaterialIssueEntry",
        component: <FrmIndentMaterialIssueEntry />,
        header: true,
        footer: true,
        protected: false
    },
    {
        type: "Masters",
        name: "Professional Taxation",
        route: "/Masters/MProfessionalTaxation/FrmProfessionalTaxationEntry",
        component: <FrmProfessionalTaxationEntry />,
        header: true,
        footer: true,
        protected: false
    },

    //production transaction
    {
        type: "sales",
        name: "Production",
        key: "Production",
        route: "/Transactions/TProduction/FrmProductionListing",
        component: <FrmProductionListing />,
        noCollapse: true,
    },
    {
        name: "Production",
        route: "/Transactions/TProduction/FrmProductionEntry",
        component: <FrmProductionEntry />,
    },


    // Codification Master
    {
        type: "Masters",
        name: "Codification",
        route: "/Masters/MCodification/MCodificationList",
        component: <MCodificationListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        name: "Production",
        route: "/Masters/MCodification/FrmMCodificationEntry",
        component: <FrmMCodificationEntry />,
    },

    // Bank List Master
    {
        type: "Masters",
        name: "Bank List",
        route: "/Masters/MBankList/FrmBankListListing",
        component: <FrmBankListListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        name: "Bank List",
        route: "/Masters/MBankList/FrmBankListEntry",
        component: <FrmBankListEntry />,
    },

    // Customer Material Issue
    {
        type: "purchase",
        name: "Customer Material Issue",
        route: "/Transactions/TCustomerMaterialIssue/TCustomerMaterialIssueListing",
        component: <TCustomerMaterialIssueListing />,
        header: true,
        footer: true,
        protected: false
    },
    {
        route: "/Transactions/TCustomerMaterialIssue/TCustomerMaterialIssueEntry",
        component: <TCustomerMaterialIssueEntry />,
        header: true,
        footer: true,
        protected: false
    },

    //-------------------------------------------- Registers--------------------------------------------------------------------------------------
    //company
    {
        type: "registers",
        name: "Companies Register",
        key: "Registers",

        route: "/Masters/CompanyListing/reg",
        component: <FrmMCompanyList compType='Register' />,
        noCollapse: true,
    },

    // Customer
    {
        type: "registers",
        name: "Customers Register",
        key: "Customers",

        route: "/Masters/CustomerListing/reg",
        component: <FrmMCustomerList compType='Register' />,
        noCollapse: true,
    },


    // bank 
    {
        type: "registers",
        name: "Bank Register",
        key: "Bank",

        route: "/Masters/BankListing/reg",
        component: <FrmMBankList compType='Register' />,
        noCollapse: true,
    },

    // Transporter
    {
        type: "registers",
        name: "Transporter Register",
        key: "Transporter",

        route: "/Masters/TransporterListing/reg",
        component: <FrmMTransporterList compType='Register' />,
        noCollapse: true,
    },
    //comman Paramitar Master
    {
        type: "registers",
        name: "Common Parameter Register",
        key: "CommonParameter",

        route: "/Masters/MCommonParameter/CommonParamterListing/reg",
        component: <CommonParamterListing compType='Register' />,
        noCollapse: true,
    },



    // Contractor
    {
        type: "registers",
        name: "Contractors Register",
        key: "Contractors",

        route: "/Masters/ContractorListing/reg",
        component: <FrmMContractorList compType='Register' />,
        noCollapse: true,
    },

    //department
    {
        type: "registers",
        name: "Department Register",
        key: "Department",

        route: "/Masters/DepartmentListing/reg",
        component: <FrmMDepartmentList compType='Register' />,
        noCollapse: true,
    },
    // Designation 
    {
        type: "registers",
        name: "Designation Register",
        key: "Designation",

        route: "/Masters/DesignationListing/reg",
        component: <FrmMDesignationList compType='Register' />,
        noCollapse: true,
    },

    // City 
    {
        type: "registers",
        name: "City Register",
        key: "City",

        route: "/Masters/CityListing/reg",
        component: <FrmCityList compType='Register' />,
        noCollapse: true,
    },

    // Supplier Masters
    {
        type: "registers",
        name: "Supplier Register",
        key: "Supplier",

        route: "/Masters/SupplierListing/reg",
        component: <FrmSpplierList compType='Register' />,
        noCollapse: true,
    },

    // Destination
    {
        type: "registers",
        name: "Destination Register",
        key: "Destination",

        route: "/Masters/DestinationListing/reg",
        component: <FrmMDestinationList compType='Register' />,
        noCollapse: true,
    },

    // Product Raw Material
    {
        type: "registers",
        name: "RawMaterial Register",
        key: "RawMaterial",

        route: "/Masters/RawMaterialListing/reg",
        component: <FrmMProductRawMaterialList compType='Register' />,
        noCollapse: true,
    },

    // Agent 

    {
        type: "registers",
        name: "Agent Register",
        key: "Agent",

        route: "/Masters/AgentListing/reg",
        component: <FrmAgentList compType='Register' />,
        noCollapse: true,
    },

    // ProductFGMaster
    {
        type: "registers",
        name: "Finish Goods Register",
        key: "ProductFG",

        route: "/Masters/FinishGoodsListing/reg",
        component: <FrmMProductFGList compType='Register' />,
        noCollapse: true,
    },

    // Taxation
    {
        type: "registers",
        name: "Taxation Register",
        key: "Taxation",

        route: "/Masters/TaxationListing/reg",
        component: <FrmMTaxationList compType='Register' />,
        noCollapse: true,
    },

    // Taxtype 
    {
        type: "registers",
        name: "Taxtype Register",
        key: "Taxtype",

        route: "/Masters/TaxtypeListing/reg",
        component: <FrmMTaxtypeList compType='Register' />,
        noCollapse: true,
    },
    // HSN-SAC
    {
        type: "registers",
        name: "HSN-SAC Register",
        key: "HSN-SAC",

        route: "/Masters/HSNSACListing/reg",
        component: <FrmMHSNSACList compType='Register' />,
        noCollapse: true,
    },

    // Product Type Master
    {
        type: "registers",
        name: "ProductType Register",
        key: "ProductType",

        route: "/Masters/ProductTypeListing/reg",
        component: <FrmMProductTypeListing compType='Register' />,
        noCollapse: true,
    },

    //Employees 

    {
        type: "registers",
        name: "Employees Register",
        key: "Employees",

        route: "/Masters/EmployeesListing/reg",
        component: <FrmMEmployeeList compType='Register' />,
        noCollapse: true,
    },

    // Product Category1 

    {
        type: "registers",
        name: "Product Category-1 Register",
        key: "ProductCategory1",

        route: "/Masters/ProductCategory1Listing/reg",
        component: <FrmMProductCategory1Listing compType='Register' />,
        noCollapse: true,
    },

    // ProductCategory2 Type
    {
        type: "registers",
        name: "Product Category-2 Register",
        key: "ProductCategory2",

        route: "/Masters/ProductCategory2Listing/reg",
        component: <FrmMProductCategory2Listing compType='Register' />,
        noCollapse: true,
    },

    // ProductCategory3 Type 
    {
        type: "registers",
        name: "Product Category-3 Register",
        key: "ProductCategory3",

        route: "/Masters/ProductCategory3Listing/reg",
        component: <FrmMProductCategory3Listing compType='Register' />,
        noCollapse: true,
    },

    // ProductCategory4 Type 
    {
        type: "registers",
        name: "Product Category-4 Register",
        key: "ProductCategory4",

        route: "/Masters/ProductCategory4Listing/reg",
        component: <FrmMProductCategory4Listing compType='Register' />,
        noCollapse: true,
    },

    // ProductCategory5 Type 
    {
        type: "registers",
        name: "Product Category-5 Register",
        key: "ProductCategory5",

        route: "/Masters/ProductCategory5Listing/reg",
        component: <FrmMProductCategory5Listing compType='Register' />,
        noCollapse: true,
    },

    // Godown
    {
        type: "registers",
        name: "Godown Register",
        key: "Godown",

        route: "/Masters/GodownListing/reg",
        component: <FrmGodownList compType='Register' />,
        noCollapse: true,
    },

    // Product Make 
    {
        type: "registers",
        name: "Product Make Register",
        key: "ProductMake",

        route: "/Masters/ProductMakeListing/reg",
        component: <FrmMProductMakeListing compType='Register' />,
        noCollapse: true,
    },

    // Product Material Grade
    {
        type: "registers",
        name: "Product Material Grade Register",
        key: "ProductMaterialGrade",

        route: "/Masters/ProductMaterialGradeListing/reg",
        component: <FrmMProductMaterialGradeListing compType='Register' />,
        noCollapse: true,
    },
    // Product Material Type
    {
        type: "registers",
        name: "Product Material Type Register",
        key: "ProductMaterialType",

        route: "/Masters/ProductMaterialTypeListing/reg",
        component: <FrmMProductMaterialTypeListing compType='Register' />,
        noCollapse: true,
    },

    // Product Packing
    {
        type: "registers",
        name: "Product Packing Register",
        key: "ProductPacking",

        route: "/Masters/ProductPackingListing/reg",
        component: <FrmMProductPackingListing compType='Register' />,
        noCollapse: true,
    },
    // Product Qa Parameters
    {
        type: "registers",
        name: "Product Qa Parameters Register",
        key: "ProductQaParameters",

        route: "/Masters/ProductQaParametersListing/reg",
        component: <FrmMProductQaParametersListing compType='Register' />,
        noCollapse: true,
    },

    // Product Rejection Parameters
    {
        type: "registers",
        name: "Product Rejection Parameters Register",
        key: "ProductRejectionParameters",

        route: "/Masters/ProductRejectionParametersListing/reg",
        component: <FrmMProductRejectionParametersListing compType='Register' />,
        noCollapse: true,
    },

    // Product Material Measure  Parameters 
    {
        type: "registers",
        name: "Product Material Measure Parameters Register",
        key: "ProductMaterialMeasureParameters",

        route: "/Masters/ProductMaterialMeasureParametersListing/reg",
        component: <FrmMProductMaterialMeasureParametersListing compType='Register' />,
        noCollapse: true,
    },

    // Product Material Shape 
    {
        type: "registers",
        name: "Product Material Shape Register",
        key: "ProductMaterialShape",

        route: "/Masters/ProductMaterialMeasureShapeListing/reg",
        component: <FrmMProductMaterialShapeListing compType='Register' />,
        noCollapse: true,
    },

    // Product Process 
    {
        type: "registers",
        name: "Product Process Register",
        key: "ProductProcess",

        route: "/Masters/FrmMProductProcessListing/reg",
        component: <FrmMProductProcessList compType='Register' />,
        noCollapse: true,
    },

    // Product Unit 
    {
        type: "registers",
        name: "Product Unit Register",
        key: "ProductUnit",

        route: "/Masters/FrmProductUnitListing/reg",
        component: <FrmProductUnitListing compType='Register' />,
        noCollapse: true,
    },

    // Product Unit Conversion 
    {
        type: "registers",
        name: "Product Unit Conversion Register",
        key: "ProductUnitConversion",

        route: "/Masters/FrmproductUnitConversionListing/reg",
        component: <FrmproductUnitConversionListing compType='Register' />,
        noCollapse: true,
    },

    // Property
    {
        type: "registers",
        name: "Property Register",
        key: "PropertyMaster",

        route: "/Masters/FrmPropertyListing/reg",
        component: <FrmPropertyListing compType='Register' />,
        noCollapse: true,
    },

    //Shift 
    {
        type: "registers",
        name: "Shift Register",
        key: "Shift",

        route: "/Masters/FrmShiftListing/reg",
        component: <FrmShiftListing compType='Register' />,
        noCollapse: true,
    },
    //cost center
    {
        type: "registers",
        name: "Cost Center Register",
        key: "CostCenter",

        route: "/Masters/MCostCenterListing/reg",
        component: <MCostCenterListing compType='Register' />,
        noCollapse: true,
    },
    //profit center
    {
        type: "registers",
        name: "Profit Center Register",
        key: "ProfitCenter",

        route: "/Masters/ProfitCenterListing/reg",
        component: <ProfitCenterListing compType='Register' />,
        noCollapse: true,
    },

    //ScheduleLedger
    {
        type: "registers",
        name: "Schedule Ledger Register",
        key: "ScheduleLedgerMaster",

        route: "/Masters/MFMScheduleLedgerListing/reg",
        component: <MFMScheduleLedgerListing compType='Register' />,
        noCollapse: true,
    },

    //General ScheduleLedger
    {
        type: "registers",
        name: "General Ledger Register",
        key: "GeneralLedgerMaster",

        route: "/Masters/MFMGeneralLedgerListing/reg",
        component: <MFMGeneralLedgerListing compType='Register' />,
        noCollapse: true,
    },
    //module form
    // {
    //   type: "registers",
    //   name: "Module Form Register",
    //   key: "ModuleForm",
    //   
    //   route: "/Masters/ModuleFormListing/reg",
    //   component: <ModuleFormListing compType='Register'/>,
    //   noCollapse: true,
    // },

    //service 
    {
        type: "registers",
        name: "Service Register",
        key: "Service",

        route: "/Masters/FrmMServiceListing/reg",
        component: <FrmMServiceListing compType='Register' />,
        noCollapse: true,
    },

    //PaymentTerms
    {
        type: "registers",
        name: "Payment Terms Register",
        key: "PaymentTerms",

        route: "/Masters/FrmPaymentTermsListing/reg",
        component: <FrmPaymentTemrsListing compType='Register' />,
        noCollapse: true,
    },

    //MPaymentSchedule
    {
        type: "registers",
        name: "Payment Schedule Register",
        key: "PaymentSchedule",

        route: "/Masters/FrmPaymentScheduleListing/reg",
        component: <FrmPaymentScheduleListing compType='Register' />,
        noCollapse: true,
    },

    // Machine
    {
        type: "registers",
        name: "Machine Register",
        key: "Machine Master",

        route: "/Masters/FrmMachineListing/reg",
        component: <FrmMachineListing compType='Register' />,
        noCollapse: true,
    },
    //Plant
    {
        type: "registers",
        name: "Plant Register",
        key: "Plant Master",

        route: "/Masters/FrmPlantlist/reg",
        component: <FrmPlantlist compType='Register' />,
        noCollapse: true,
    },

    //bank Listing 
    {
        type: "registers",
        name: "Bank Listing  Register",
        key: "Bank Listing ",

        route: "/Masters/MBankList/FrmBankListListing/reg",
        component: <FrmBankListListing compType='Register' />,
        noCollapse: true,
    },
    // Job Type Master
    {
        type: "registers",
        name: "Job Type Register",
        key: "Job Type",

        route: "/Masters/MJobType/FrmJobTypeListing/reg",
        component: <FrmJobTypeListing compType='Register' />,
        noCollapse: true,
    },
    //Templates Communications Master
    {
        type: "registers",
        name: "Templates Communications Register",
        key: "Templates Communications",

        route: "/Masters/MCommunicationsMaster/FrmCommunicationsMasterList/reg",
        component: <FrmCommunicationsMasterList compType='Register' />,
        noCollapse: true,
    },

    // hm_earning_heads 
    {
        type: "registers",
        name: "Earning Heads Register",
        key: "Earning Heads",

        route: "/Masters/MHMEarningHeads/MHMEarningHeadsListing/reg",
        component: <FrmMHMEarningHeadsListing compType='Register' />,
        noCollapse: true,
    },

    //Production Count Master
    {
        type: "registers",
        name: "Production Count Register",
        key: "Production Count",

        route: "/Masters/MCount/FrmCountListing/reg",
        component: <FrmCountListing compType='Register' />,
        noCollapse: true,
    },

    //Production Holiday 
    {
        type: "registers",
        name: "Production Holiday Register",
        key: "Production Holiday",

        route: "/Masters/MHoliday/FrmHolidayListing/reg",
        component: <FrmHolidayListing compType='Register' />,
        noCollapse: true,
    },

    // hm_Deduction_heads
    {
        type: "registers",
        name: "Deduction Heads Register",
        key: "Deduction Heads ",

        route: "/Masters/MHMDeductionHeads/FrmMHMDeductionHeadsListing/reg",
        component: <FrmMHMDeductionHeadsListing compType='Register' />,
        noCollapse: true,
    },

    //Production Process 
    {
        type: "registers",
        name: "Production Process Register",
        key: "Production Process",

        route: "/Masters/MProductionProcess/MFrmProductionProcessListing/reg",
        component: <MFrmProductionProcessListing compType='Register' />,
        noCollapse: true,
    },

    //Production Stoppage Reasons 
    {
        type: "registers",
        name: "Production Stoppage Reasons Register",
        key: "Production Stoppage Reasons",

        route: "/Masters/MProductionStoppageReasons/MFrmProductionStoppageReasonsListing/reg",
        component: <MFrmProductionStoppageReasonsListing compType='Register' />,
        noCollapse: true,
    },
    //Production Wastage Master
    {
        type: "registers",
        name: "Production Wastage Types Register",
        key: "Production Wastage Types",

        route: "/Masters/MProductionWastageType/MFrmProductionWastageTypesListing/reg",
        component: <MFrmProductionWastageTypesListing compType='Register' />,
        noCollapse: true,
    },

    //Production Electrical Meter Entry 
    {
        type: "registers",
        name: "Production Electrical Meter Register",
        key: "Production Electrical Meter",

        route: "/Masters/MProductionElectricalMeter/MFrmProductionElectricalMeterListing/reg",
        component: <MFrmProductionElectricalMeterListing compType='Register' />,
        noCollapse: true,
    },
    // production spinning plan parameter 
    {
        type: "registers",
        name: "Production Spinning Plan Parameter Register",
        key: "Production Spinning Plan Parameter ",

        route: "/Masters/MXMProductionSpinningPlanParameter/FrmMProductionSpinningPlanParameterListing/reg",
        component: <FrmMProductionSpinningPlanParameterListing compType='Register' />,
        noCollapse: true,
    },

    //Maintance task activity
    {
        type: "registers",
        name: "Maintenance Task Activity Register",
        key: "Maintenance Task Activity",

        route: "/Masters/MmaintenanceTaskActivity/MmaintenanceTaskActivityListing/reg",
        component: <MmaintenanceTaskActivityListing compType='Register' />,
        noCollapse: true,
    },

    //Maintance master and details
    {
        type: "registers",
        name: "Maintenance Task Master Register",
        key: "Maintenance Task Master",

        route: "/Masters/MmaintenanceTaskMaster/FrmMaintenanceTaskMasterListing/reg",
        component: <FrmMaintenanceTaskMasterListing compType='Register' />,
        noCollapse: true,
    },

    // Sales 
    //Enquiry trading Management
    {
        type: "registers",
        name: "Enquiry Management (Trading) Register",
        key: "EnquiryManagement",

        route: "/Transactions/TEnquiryManagement/FrmEnquiryListing/reg",
        component: <FrmEnquiryListing compType='Register' />,
        noCollapse: true,
    },

    //Enquiry Servises
    {
        type: "registers",
        name: "Enquiry Management (Service) Register",
        key: "EnquiryServiceManagement",

        route: "/Transactions/TEnquiryServiceManagement/FrmEnquiryServiceListing/reg",
        component: <FrmEnquiryServiceListing compType='Register' />,
        noCollapse: true,
    },

    //Quotation 
    {
        type: "registers",
        name: "Quotation (Trading) Register",
        key: "Quotation",

        route: "/Transactions/TQuotation/FrmQuotationListing/reg",
        component: <FrmQuotationListing compType='Register' />,
        noCollapse: true,
    },

    //Quotation Servises
    {
        type: "registers",
        name: "Quotation (Service) Register",
        key: "QuotationService",

        route: "/Transactions/TQuotationService/FrmQuotationServiceListing/reg",
        component: <FrmQuotationServiceListing compType='Register' />,
        noCollapse: true,
    },

    // Sales Order Trading.
    {
        type: "registers",
        name: "Sales Order (Trading) Register",
        key: "Sales Order",

        route: "/Transactions/TSalesOrder/SalesOrderListing/reg",
        component: <SalesOrderListing compType='Register' />,
        noCollapse: true,
    },
    // Sales Order Service.
    {
        type: "registers",
        name: "Sales Order (Services) Register",
        key: "Sales Order Services",

        route: "/Transactions/TSalesOrder/Services/SOServiceListing/reg",
        component: <SOServiceListing compType='Register' />,
        noCollapse: true,
    },

    //Dispatch Note
    {
        type: "registers",
        name: "Dispatch Note (Trading) Register",
        key: "DispatchNote",

        route: "/Transactions/TDispatchNote/TDispatchNoteListing/reg",
        component: <TDispatchNoteListing compType='Register' />,
        noCollapse: true,
    },

    // Dispatch-Challan Trading.
    {
        type: "registers",
        name: "Dispatch Challan (Trading) Register",
        key: "Dispatch Challan",

        route: "/Transactions/TDispatchChallan/TDispatchChallanListing/reg",
        component: <TDispatchChallanListing compType='Register' />,
        noCollapse: true,
    },

    // SalesInvoice
    {
        type: "registers",
        name: "Sales Invoice (Trading) Register",
        key: "Sales Invoice",

        route: "/Transactions/SalesInvoiceListing/reg",
        component: <FrmSalesInvoiceListing compType='Register' />,
        noCollapse: true,
    },

    // purchase payment Customer Transition
    {
        type: "registers",
        name: "Customer Sales Receipt Register",
        key: "customerSalesReceipt",

        route: "/Transactions/TPurchaseOrder/TPurchasePaymentCustomer/FrmCustomerSalesReceiptListing/reg",
        component: <FrmCustomerSalesReceiptListing compType='Register' />,
        noCollapse: true,
    },

    // Goods Receipt Notes
    {
        type: "registers",
        name: "Goods Receipt Notes Register",
        key: "Goods Receipt Notes",

        route: "/Transactions/TPurchaseOrder/GoodsReceiptNote/GoodsReceiptNoteListing/reg",
        component: <FrmGoodsReceiptNoteListing compType='Register' />,
        noCollapse: true,
    },

    //Purchase Bill Book Auto
    {
        type: "registers",
        name: "Purchase Bill Book(Auto) Register",
        key: "BillBook",

        route: "/Transactions/TPurchaseOrder/TBillBook/BillBookListing/reg",
        component: <BillBookListing compType='Register' />,
        noCollapse: true,
    },

    // Manual Bill Book
    {
        type: "registers",
        name: "Purchase Bill Book(Manual) Register",
        key: "ManualBillBook",

        route: "/Transactions/TPurchaseOrder/TManualBillBook/FrmManualBillBookListing/reg",
        component: <FrmManualBillBookListing compType='Register' />,
        noCollapse: true,
    },

    // Purchase Payment 
    {
        type: "registers",
        name: "Purchase Payment Supplier Register",
        key: "PurchasePaymentSupplier",

        route: "/Transactions/TPurchaseOrder/TPurchasePaymentSupplier/FrmPurchasePaymentSupplierListng/reg",
        component: <FrmPurchasePaymentSupplierListing compType='Register' />,
        noCollapse: true,
    },

    // smv_product_fg_stock listing
    {
        type: "registers",
        name: "Finish Goods Stock Register",
        key: "Product finish goods Stock",

        route: "/Masters/MSMVProductFgStock/FrmMSMVProductFgStocklisting",
        component: <FrmMSMVProductFgStocklisting />,
        noCollapse: true,
    },

    // Product Rm Stock listing
    {
        type: "registers",
        name: "Raw Material Stock Register",
        key: "Product Raw Material Stock",

        route: "/Masters/MSMVProductRmStock/FrmMSMVProductRmStockListing",
        component: <FrmMSMVProductRmStockListing />,
        noCollapse: true,
    },

    //Purchase Requisition 
    {
        type: "registers",
        name: "Purchase Requisition Register",
        key: "Indent",

        route: "/Transactions/TPurchaseOrder/Indent/IndentListing/reg",
        component: <IndentListing compType='Register' />,
        noCollapse: true,
    },
    //Purchase Requisition (BOM)
    {
        type: "registers",
        name: "Purchase Requisition (BOM) Register",
        key: "Good Reciept Notes",

        route: "/Transactions/TPurchaseOrder/PurchaseRequisition/FrmPurchaseRequisitionListing/reg",
        component: <FrmPurchaseRequisitionListing compType='Register' />,
        noCollapse: true,

    },

    //Manual PO Transition
    {
        type: "registers",
        name: "Purchase Order (Trading) Register",
        key: "PurchaseOrder",

        route: "/Transactions/TPurchaseOrder/ManualPO/ManualPOListing/reg",
        component: <POListing compType='Register' />,
        noCollapse: true,
    },



];

export default routes;